/**
 * @typedef {Object} AddressDetail
 * @property {number} placeId
 * @property {string} text1
 * @property {string} city
 * @property {string} country
 * @property {number} lat
 * @property {number} lng
 */

(function (angular) {
  angular.module("mobilezuz").controller("GoogleMapDialogCtrl", [
    "mDesign",
    "$scope",
    "LocationService",
    "GOOGLE_MAP_ADDRESS_TYPES",
    "Util",
    "GMap",
    function (mDesign, $scope, LocationService, GOOGLE_MAP_ADDRESS_TYPES, Util, GMap) {
      var googleMapDialogCtrl = this;
      var DEFAULT_ZOOM = 18

      angular.extend(googleMapDialogCtrl, {
        isShowAutoComplete: true,
        markerPopup: null,
        addressDetail: {
          lat: 0,
          lng: 0,
          city: '',
          text1: '',
          country: '',
          placeId: '',
          zipCode: '',
          hasHouseNumberAndRoute: true,
        },
        formattedAddress: "",
        mapErrorMessage: "",
        searchQuery: "",

        handleCloseDialog: handleCloseDialog,
      });

      _init();

      //================== PRIVATES FUNCTIONS  ==================//

      /**
       * @param {AddressComponents[]} addressComponents
       * @returns {{houseNumber: string, route: string, city: string, country: string, countryCode: string, zipCode: string}}
       */
      function _extractInfoFromAddrComponents(addressComponents) {
        var initialResult = {
          houseNumber: "",
          route: "",
          city: "",
          country: "",
          zipCode: "",
          countryCode: "",
        };
        return addressComponents.reduce(function (result, component) {
          var types = component.types;
          var longName = component.long_name;
          var shortName = component.short_name;

          types.forEach(function (type) {
            switch (type) {
              case GOOGLE_MAP_ADDRESS_TYPES.STREET_NUMBER:
              case GOOGLE_MAP_ADDRESS_TYPES.PREMISE: {
                result.houseNumber = longName;
                break;
              }
              case GOOGLE_MAP_ADDRESS_TYPES.ROUTE:
              case GOOGLE_MAP_ADDRESS_TYPES.ESTABLISHMENT:   {
                result.route = longName;
                break;
              }
              case GOOGLE_MAP_ADDRESS_TYPES.LOCALITY:
              case GOOGLE_MAP_ADDRESS_TYPES.SUB_LOCALITY:
              case GOOGLE_MAP_ADDRESS_TYPES.NEIGHBORHOOD:
              case GOOGLE_MAP_ADDRESS_TYPES.POSTAL_TOWN: {
                result.city = longName;
                break;
              }
              case GOOGLE_MAP_ADDRESS_TYPES.COUNTRY: {
                result.country = longName;
                result.countryCode = shortName;
                break;
              }
            }
          });
          return result;
        }, initialResult);
      }

      function _setAddress(geocode) {
        var extractedInfo = _extractInfoFromAddrComponents(geocode.address_components);
        googleMapDialogCtrl.formattedAddress = geocode.formatted_address;
        var text1Obj = Util.constructAdrsText1(extractedInfo.countryCode, extractedInfo.houseNumber, extractedInfo.route, extractedInfo.city);
        angular.extend(googleMapDialogCtrl.addressDetail, {
          lng: geocode.geometry.location.lng(),
          lat: geocode.geometry.location.lat(),
          placeId: geocode.place_id,
          city: extractedInfo.city,
          text1: text1Obj.value,
          country: extractedInfo.country,
          zipCode: extractedInfo.zipCode,
          hasHouseNumberAndRoute: text1Obj.hasHouseNumberAndRoute
        });
        $scope.$applyAsync();
      }

      /**
       * @param {GeoLocation}
       * @returns {Promise<google.maps.Map>}
       */
      function _initMap(defaultLocation) {
        var mapRef = document.getElementById("map");
        var mapOptions = {
          zoom: DEFAULT_ZOOM,
          center: defaultLocation,
        };

        return GMap.initMap(mapRef, mapOptions)
      }

      /**
       * @param {GeoLocation} location refer service/google-map
       */
      function _setAddressFromLocation(location) {
        GMap.reverseGeocode(location).then(function (geocode) {
          _setAddress(geocode);
        });
      }

      /**
       * @param {google.maps.Map} map
       * @param {{lat: number, lng: number}} defaultLocation
       * @returns {google.maps.Marker}
       */
      function _initMarker(map, location) {
        var marker = GMap.initMarker(map, location);
        _addMarkerEventListener(map, marker);
        return marker;
      }

      /**
       * @param {google.maps.Map} map
       * @param {google.maps.Marker} marker
       */
      function _addMarkerEventListener(map, marker) {
        GMap.addDragMarkerEventLister(marker, _setAddress);
        GMap.addClickMapMoveMarkerEventListener(marker, map, _setAddress);
        googleMapDialogCtrl.markerPopup = GMap.initInfoWindow(null);

        GMap.clickMarkerTogglePopupListener({
          map: map,
          marker: marker,
          infoWindow: googleMapDialogCtrl.markerPopup,
        });
      }

      /**
       * @param {GeoLocation} location
       * @param {google.maps.Map} map
       */
      function _initAutoComplete(location, map, marker) {
        var inputRef = document.getElementById("pac-input");
        if (!inputRef) {
          return;
        }
        var autocomplete = GMap.initAutoComplete(inputRef, location, map);
        GMap.addAutocompleteChangeEventListener(autocomplete, map, marker, _setAddress);
      }

      function initGoogleMapWeb(defaultLocation) {
        _initMap(defaultLocation).then(function (map) {
          var marker = _initMarker(map, defaultLocation);
          _initAutoComplete(defaultLocation, map, marker);
        });
      }

      function _init() {
        LocationService.getUserDefaultLocation()
          .then(function (defaultLocation) {
            // close dialog so can see alert error
            if (!defaultLocation) {
              return handleCloseDialog();
            }

            _setAddressFromLocation(defaultLocation);

            initGoogleMapWeb(defaultLocation);
          })
          .catch(function (error) {
            googleMapDialogCtrl.mapErrorMessage = error.message;
          });
      }

      //================== PUBLIC FUNCTIONS  ==================//
      function handleCloseDialog(data) {
        mDesign.hide(data);
      }

      //================== SCOPE LISTENER  ==================//
      $scope.$watch("googleMapDialogCtrl.formattedAddress", function () {
        GMap.setContentInfoWindow(
          googleMapDialogCtrl.markerPopup,
          GMap.formatPopupContent(googleMapDialogCtrl.formattedAddress)
        );
      });
    },
  ]);
})(angular);
